import { Injectable, signal, TemplateRef } from '@angular/core';

export interface ToastOptions {
  delay?: number;
  classname?: string;
  autohide?: boolean;
  closeButton?: boolean;
  /** Close the toast on click anywhere inside it (default true); set false to allow selecting/copying the text. */
  closeOnClick?: boolean;
}

export interface Toast extends ToastOptions {
  textOrTpl: string | TemplateRef<any>;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts = signal<Toast[]>([]);

  show(textOrTpl: string | TemplateRef<any>, options: ToastOptions = { autohide: true }) {
    this.toasts.update((toasts) => [...toasts, { textOrTpl, ...options }]);
  }

  info(textOrTpl: string | TemplateRef<any>, title?: string) {
    this.show(textOrTpl);
  }

  success(textOrTpl: string | TemplateRef<any>, title?: string, options?: ToastOptions) {
    const defaultOptions: ToastOptions = { classname: 'bg-success', autohide: true, closeButton: false };
    this.show(textOrTpl, { ...defaultOptions, ...options });
  }

  warning(textOrTpl: string | TemplateRef<any>, title?: string, options?: ToastOptions) {
    const defaultOptions: ToastOptions = { classname: 'bg-warning text-dark', autohide: true, closeButton: false };
    this.show(textOrTpl, { ...defaultOptions, ...options });
  }

  error(textOrTpl: string | TemplateRef<any>, title?: string, options?: ToastOptions) {
    const defaultOptions: ToastOptions = { classname: 'bg-danger text-light', autohide: true, closeButton: false };
    this.show(textOrTpl, { ...defaultOptions, ...options });
  }

  remove(toast: Toast) {
    this.toasts.update((toasts) => toasts.filter((t) => t !== toast));
  }

  clear() {
    this.toasts.set([]);
  }
}
